module.exports = __webpack_public_path__ + "img/avatar_placeholder.0a0633da.png";